<template>
    <header class="appHeader">
        <div class="headerLeft" v-show="!isConfirmationPage">
            <a href="javascript:;"
               @click="goBack">
                <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
            </a>
        </div>
        <div class="headerCenter">
            <a href="/"
                         class="headerHomeLink">
                <img class="appLogo" src="/img/logo.svg"
                     alt="True Security Logo" />
                <!-- <div class="logoAdtAuthorizedCompany"> an ADT Authorized Company </div> -->
            </a>
        </div>
        <div class="headerRight hideOnMobile" v-show="!isConfirmationPage">
            <PhoneLink location="header" />
            <router-link to="/help">Help</router-link>
            <button class="guideButton" type="button" @click="toggleTalkWithGuideVisible" :class="{'active': talkWithGuideVisible}" v-if="talkWithGuideButtonVisible">
                Talk with a guide
                <i class="fa fa-chevron-down"></i>
            </button>
        </div>
        <div class="headerRight hideOnDesktop" v-show="!isConfirmationPage">
            <a href="javascript:;" @click="toggleSlideout">Help</a>
        </div>
        <vue-progress-bar />
    </header>
</template>


<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import PhoneLink from './PhoneLink.vue'
import VueProgressBar from 'vue-progressbar'
export default {
    components: {
        'v-progress-bar': VueProgressBar,
        PhoneLink
    },
    data: () => ({}),
    computed: {
        ...mapState([
            'areaOfConcernSectionIndex',
            'headerNumber',
            'headerNumberLink',
            'talkWithGuideVisible'
        ]),

        isAreaOfConcern() {
            return this.$route.path === '/areas-of-concern'
        },

        isConfirmationPage() {
            return this.$route.path === '/complete'
        },

        talkWithGuideButtonVisible() {
            let path = this.$route.path
            let hideOn = [
                '/'
            ]
            return !hideOn.includes(path)
        },

    },
    methods: {
        ...mapActions([
            'incrementAocSectionIndex',
            'decrementAocSectionIndex',
            'setAocSectionIndex',
            'updateAreaOfConcern',
            'toggleSlideout',
            'toggleTalkWithGuideVisible'
        ]),
        goBack() {
            if (this.isAreaOfConcern && this.areaOfConcernSectionIndex > -1) {
                this.decrementAocSectionIndex()
                if (this.areaOfConcernSectionIndex ===  -1) {
                    this.updateAreaOfConcern({ name: '' })
                }
                return ;
            }

            // if (this.isAreaOfConcern && this.areaOfConcernSectionIndex <= -1) {
            //     this.updateAreaOfConcern({ name: '' })
            //     return ;
            // }

            this.$router.go(-1)
        }
    },
    mounted() {
        // this.$Progress.set(50)
    }
}
</script>

<style lang="css"></style>
